import { Image, UIHeading4, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface IDataItemProps {
  header: string;
  text: string;
  image?: string | null;
}

export const DataItem: React.FC<IDataItemProps> = ({ image, header, text }) => {
  return (
    <div className={styles['item']}>
      {image && image.length ? (
        <div className={styles['image']}>
          {<Image src={image} borderRadius="4px" width={44} height={44} objectFit="contain" />}
        </div>
      ) : null}
      <div>
        <UIText2 color="gray60_100">{header}</UIText2>
        <UIHeading4 color="black_100">{text}</UIHeading4>
      </div>
    </div>
  );
};
